<div class="FormsMain {{inModal ? 'FormsMain--InModal' : ''}}">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
    }
    @if (notFound) {
        <div>
            <div class="FormsMain-Heading mb-3 d-block d-sm-flex flex-row-reverse">
                <div class="text-end pb-2">
                    <button type="button" class="btn btn-sm btn-secondary ms-1" (click)="cancelEdit.emit()">
                        <i class="fa-regular fa-undo" aria-hidden="true"></i>
                        <span>{{ 'forms-main.cancel' | locTranslate }}</span>
                    </button>
                </div>
                <h2>
                    {{ 'forms-main.not-found' | locTranslate }}
                </h2>
            </div>
        </div>
    }
    @if (!notFound) {
        <div>
            @if (!viewOnly) {
                <div class="FormsMain-Heading mb-3 d-block d-sm-flex flex-row-reverse">
                    <div class="text-end">
                        @if (isSupplier && !hasPreviousButton()) {
                            <button type="button" class="btn btn-secondary" (click)="openModalImportData()">
                                <span>{{ 'forms-data-import.title' | locTranslate }}</span>
                                <i class="fa-regular fa-download" aria-hidden="true"></i>
                            </button>
                        }
                    </div>
                    <h2>
                        @if (currentState != null) {
                            {{formFlow.states[currentState].title | locTranslate}}
                        }
                        @if (currentState == null) {
                            {{ 'forms-main.summary' | locTranslate }}
                        }
                    </h2>
                </div>
                @if (flowSteps != null) {
                    <div #progressCont class="FormsMain-Progress mb-3" role="navigation" [attr.aria-label]="'forms-main.a11y.progress-nav' | locTranslate">
                        <div class="FormsMain-Progress-Inner" [style.width]="(getFlowStepsLength() * 8) + 'rem'">
                            <div>
                                <div class="progress">
                                    <div class="progress-bar progress-bar-primary" role="progressbar"
                                        [attr.aria-valuemin]="0"
                                        [attr.aria-valuemax]="100"
                                        [attr.aria-valuenow]="flowProgress != null ? (flowProgress * 100 | number:'1.0-0') : 0"
                                        [attr.aria-label]="'forms-main.a11y.progress' | locTranslate"
                                        [style.width]="getFlowProgressWidth()">
                                    </div>
                                </div>
                            </div>
                            <div class="FormsMain-Progress-Ticks">
                                @for (id of flowSteps; track id) {
                                    @if (formFlow.states[id]; as state) {
                                        @if (advancedMode || !state.advanced) {
                                            <button type="button" [attr.data-state-id]="id" class="{{getProgressStepClass(id)}} {{state.advanced ? 'PGHighlight--Primary' : ''}}" [style.flex]="getProgressStepFlex(id)" (click)="jumpToState(id)" [attr.aria-current]="id == currentState ? 'step' : null">
                                                <div class="FormsMain-Progress-Ticks-Label">
                                                    <small class="text-muted">
                                                        @if (state.optional) {
                                                            <span>{{ 'forms-main.optional' | locTranslate }}</span>
                                                        }
                                                        @if (!state.optional) {
                                                            <span>&nbsp;</span>
                                                        }
                                                    </small>
                                                    <span class="{{id == currentState ? 'text-primary' : 'text-dark'}}">{{state.title | locTranslate}}</span>
                                                </div>
                                            </button>
                                        }
                                    }
                                }
                            </div>
                        </div>
                    </div>
                }
                @if (isJumpingToState) {
                    <app-pg-loading [isOverlay]="true"></app-pg-loading>
                }
                @if (currentState != null) {
                    <div class="FormsMain-Content {{ isJumpingToState ? 'FormsMain-Content--JumpingToState' : ''}}">
                        @if (formFlow.states[currentState].description; as description) {
                            <p [innerHTML]="description | locTranslate"></p>
                        }
                        <!-- STATE NORMALE -->
                        @if (!formFlow.states[currentState].multi) {
                            <app-pg-form #stateForm [formLayout]="currentForm" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" [forceLanguage]="selectedLanguage" [hasCancel]="false" [hasSubmit]="false"
                            [cancelText]="formCancelText" [submitText]="formSubmitText" (valueChange)="onValueChange()" (formCancel)="onFormCancel()" (formSubmit)="onFormSubmit($event)" ></app-pg-form>
                        }
                        <!-- STATE MULTI -->
                        @if (formFlow.states[currentState].multi; as multi) {
                            @if (values[multi] != null) {
                                @for (item of values[multi]; track item; let i = $index) {
                                    <div class="card FormsMain-Multiform-Item mb-3">
                                        @if (currentStateMultiEdit == null) {
                                            <div class="card-header FormsMain-Multiform-Item-Actions">
                                                @if (i > 0) {
                                                    <button type="button" class="btn btn-sm btn-link" (click)="multiFormMove(item, -1)" [attr.aria-label]="'forms-main.a11y.move-up' | locTranslate">
                                                        <i class="fa-regular fa-chevron-up" aria-hidden="true"></i>
                                                    </button>
                                                }
                                                @if (i < values[multi].length - 1) {
                                                    <button type="button" class="btn btn-sm btn-link" (click)="multiFormMove(item, 1)" [attr.aria-label]="'forms-main.a11y.move-down' | locTranslate">
                                                        <i class="fa-regular fa-chevron-down" aria-hidden="true"></i>
                                                    </button>
                                                }
                                                <button type="button" class="btn btn-sm btn-link" (click)="multiFormEdit(item)" [attr.aria-label]="'forms-main.a11y.edit-item' | locTranslate">
                                                    <i class="fa-regular fa-edit" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" class="btn btn-sm btn-link text-danger" (click)="multiFormDelete(item)" [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                                    <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        }
                                        @if (currentStateMultiEdit != null) {
                                            <div class="card-header">
                                                <b>&nbsp;</b>
                                            </div>
                                        }
                                        <div class="card-body">
                                            <app-pg-detail [formLayout]="currentForm" [hideAdvanced]="true" [formValues]="item"></app-pg-detail>
                                        </div>
                                    </div>
                                }
                            }
                            <!-- aggiunta elemento -->
                            <div class="mb-3">
                                <button type="button" class="btn btn-primary" [disabled]="currentStateMultiEdit != null" (click)="multiFormAdd()">
                                    <span>{{ 'forms-main.add' | locTranslate }} {{formFlow.states[currentState].title | locTranslate}}</span>
                                    <i class="fa-regular fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        }
                    </div>
                }
            }
            <!-- RECAP -->
            @if (viewOnly || currentState == null) {
                <div class="FormsMain-Recap">
                    @for (id of stateHistory; track id; let i = $index) {
                        @if (formFlow.states[id]; as state) {
                            @if (!state.noRecap) {
                                <div class="mb-3">
                                    <h4 class="mb-3 pb-3 border-bottom">{{state.title | locTranslate}}</h4>
                                    <div class="mb-3">{{state.description | locTranslate}}</div>
                                    <!-- STATE NORMALE -->
                                    @if (!state.multi) {
                                        <app-pg-detail [formLayout]="state.form"></app-pg-detail>
                                    }
                                    <!-- STATE MULTI -->
                                    @if (state.multi; as multi) {
                                        @if (values[multi] != null) {
                                            @for (item of values[multi]; track item; let i = $index) {
                                                <div class="card FormsMain-Multiform-Item mb-3">
                                                    <div class="card-body">
                                                        <app-pg-detail [formLayout]="state.form" [formValues]="item"></app-pg-detail> <!-- TODO: fixare con copie di formLayout -->
                                                    </div>
                                                </div>
                                            }
                                        }
                                    }
                                </div>
                            }
                        }
                    }
                </div>
            }
            @if (!viewOnly && inModal) {
                <div class="text-end border-top pt-3">
                    <button type="button" class="btn btn-secondary" (click)="cancelEdit.emit()">
                        <i class="fa-regular fa-undo" aria-hidden="true"></i>
                        <span>{{ 'forms-main.cancel' | locTranslate }}</span>
                    </button>
                    <button type="button" [disabled]="!hasPreviousButton()" class="btn btn-secondary ms-2" (click)="previousState()">
                        <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                        <span>{{ 'forms-main.previous' | locTranslate }}</span>
                    </button>
                    <button type="button" [disabled]="!hasNextButton()" class="btn btn-primary ms-2" (click)="checkNextState()">
                        <span>{{ 'forms-main.next' | locTranslate }}</span>
                        <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                    </button>
                    <button type="button" [disabled]="currentState != null" class="btn btn-primary ms-2" (click)="checkSaveData()">
                        <span>{{ 'forms-main.save' | locTranslate }}</span>
                        <i class="fa-regular fa-save" aria-hidden="true"></i>
                    </button>
                </div>
            }
        </div>
    }
</div>

<ng-template #modalStateMultiEdit>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'forms-main.edit' | locTranslate }}</h4>
        <button type="button" class="modal-close btn btn-link" (click)="onMultiFormEditCancel()" [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body FormsMain-StateMultiEdit">
        @if (formLayoutMultiEdit != null) {
            <app-pg-form [formLayout]="formLayoutMultiEdit" [hasCancel]="true" [forceLanguage]="selectedLanguage"
                [submitText]="multiFormEditSubmitText" [cancelText]="multiFormEditCancelText"
            (formSubmit)="onMultiFormEditSubmit($event)" (formCancel)="onMultiFormEditCancel()"></app-pg-form>
        }
    </div>
</ng-template>

<ng-template #modalImportData>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'forms-data-import.title' | locTranslate }}</h4>
        <button type="button" class="modal-close btn btn-link" (click)="cancelImportData()" [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
        <app-forms-data-import (setImportData)="setImportData($event)"></app-forms-data-import>
    </div>
</ng-template>